/* eslint-disable no-unused-vars */
import React, { useContext } from "react";

import { isMobile } from "react-device-detect";

import utils from "../../../utils";
import { UmbracoContext } from "../../../components/Umbraco/UmbracoContext";
import { Button } from "meitav-uikit";

const { UmbracoUtills } = utils;

export default function HeaderLobby() {
  const resource = useContext(UmbracoContext).resource.properties;

  const moveDigitalJoin = () => {
    window.dataLayer.push({
      event: "PM - ivestment",
      eventInfo: {
        action_screen: window.location.pathname,
        process_level: "הרכב תיק ההשקעות",
        action_name: "המשך מוצלח של שלב הרכב תיק ההשקעות",
      },
    });
    window.open("/JoinPersonalDetails", "_self");
  };
  return (
    <>  
       <div
       className={`${isMobile ? "" : "mr-2"
         } headerButton`}
     >
       <Button
         variant='outlined'
         onClick={moveDigitalJoin}
         text={UmbracoUtills.getParsedHtmlValueByKey(
          resource,
           "buttonDigitalJoin"
         )}
       >
       </Button>
     </div>
     </>

  );
}
